import React, { useState } from 'react';
import { Container, Row, Col, Nav, Tab } from 'react-bootstrap';
import RegressionsTab from './RegressionsTab';

const Performance = ({ pipelines }) => {
  const [activeTab, setActiveTab] = useState('regressions');

  // Add debugging
  console.log('[DEBUG] Performance component received pipelines:', pipelines);
  console.log('[DEBUG] Performance pipelines length:', pipelines?.length);

  return (
    <Container fluid className="performance-page">
      <Row>
        <Col>
          <h2 className="mb-4">Performance Dashboard</h2>
          
          <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
            <Row>
              <Col>
                <Nav variant="tabs" className="mb-3">
                  <Nav.Item>
                    <Nav.Link eventKey="regressions">Regressions</Nav.Link>
                  </Nav.Item>
                  {/* Add more tabs here in the future */}
                </Nav>
                
                <Tab.Content>
                  <Tab.Pane eventKey="regressions">
                    <RegressionsTab pipelines={pipelines} />
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </Col>
      </Row>
    </Container>
  );
};

export default Performance; 